import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { IQuestionTypeModel } from 'models/QuestionType.Model'
import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { Button, ButtonGroup } from 'reactstrap';

type Props = {
    showModel: any,
    data: Array<any>,
    clickHandler: any,
    index: any,
    elementRef: any,
    selected: any,
    defaultSelected: IQuestionTypeModel,
    heading: IQuestionTypeModel,
    selectedId: any
}

function SearchModal({ showModel, data, clickHandler, index, selected, elementRef, defaultSelected, heading, selectedId }: Props) {
    const [filterData, setFilterData] = useState<Array<any>>([]);
    const [radioSelected, setRadioSelected] = useState<any>(defaultSelected?.Id || selectedId);

    const backToHomeHandler = (notValid: boolean) => {
        showModel(notValid);
    }

    const filterHandler = (keyWord: any) => {
        if (keyWord === "") {
            return setFilterData(data);
        }
        if (keyWord) {
            const res = data.filter(x => x.Name.toLowerCase().includes(keyWord.toLowerCase()));
            if (res && res.length > 0) {
                return setFilterData(res);
            }
        }
    }

    const onOptRadioGroup = (Id: any, questions: IQuestionTypeModel[]) => {
        if (questions && questions.length > 0) {
            for (const list of questions) {
                clickHandler(list.Id === Id, list);
                if (list.Id === Id) {
                    selected(list);
                    setRadioSelected(list.Id);
                }
            }
            showModel(false);
        }
    }
    useEffect(() => {
        setFilterData(data);
    }, [data]);

    return (
        <div>
            <div>
                <Row>
                    <Col xl="12">
                        <div className='d-flex justify-content-between my-2'>
                            <p onClick={() => backToHomeHandler(false)}><b>{heading.DisplayName}</b></p>
                            {/* <CustomButton slot="end" className="cursor-pointer" onClick={() => backToHomeHandler(false)} type={'button'} btnClassName={'btn-dark'} iconClasssName={undefined} name={'Search'}>
                                <i ></i>
                            </CustomButton> */}
                            <i className='bx bx-x align-middle dofy-admin-font-md cursor-pointer' onClick={() => showModel(false)}></i>
                        </div>
                    </Col>
                </Row>
            </div>
            <div>
                <div>
                    <Row>
                        <Col size="12">
                            <Input placeholder={`Search ${heading.DisplayName}`}
                                onChange={(e) => filterHandler(e.target.value)} />
                        </Col>
                    </Row>
                    <div className='scrollbar'>
                    <FormGroup defaultValue={radioSelected ? radioSelected : defaultSelected ? defaultSelected : selectedId} className='my-3'>
                        {filterData &&
                            filterData.map((val: IQuestionTypeModel, i) => (
                                <FormGroup check key={i} style={
                                    val.Id === (radioSelected ? radioSelected : defaultSelected ? defaultSelected : selectedId) ? {
                                        border: "2px solid #1E4496",
                                        borderRadius: "10px",
                                        background: "#1E4496",
                                        color: 'white', 
                                        width: "90%"
                                    } : undefined
                                } className='py-2 px-4'>
                                    <Label check >
                                        <Input value={val.Id} key={val.Id} defaultChecked={val.Id == (radioSelected ? radioSelected : defaultSelected ? defaultSelected : selectedId) ? true : false} onChange={(e) => onOptRadioGroup(val.Id, data)} type="radio" name="custom-radio" />
                                        <p className='text-nowrap m-0'> {val.DisplayName}</p>
                                    </Label>
                                </FormGroup>

                            ))}

                    </FormGroup>
                    </div>
                    {/* <div className='my-2'>
                        <CustomRadioGroup data={filterData} value={radioSelected ? radioSelected : defaultSelected ? defaultSelected : selectedId} displayName={'DisplayName'} direction={'vertical'} onChange={(e) => onOptRadioGroup(e.target.value, data)} />
                    </div> */}

                </div>
            </div>
        </div>
    )
}

export default SearchModal
